import { useEffect } from 'react';

type PopoverToggleEvent = Event & {
  readonly newState: 'open' | 'closed';
  readonly oldState: 'open' | 'closed';
};

export const useToggleHandler = (
  componentRef: React.RefObject<HTMLDivElement | null>,
  isOpen: boolean,
  onClose: VoidFunction
) => {
  useEffect(() => {
    const component = componentRef.current;
    if (!component) return;

    const handleToggle = (event: Event) => {
      const toggleEvent = event as PopoverToggleEvent;
      if (toggleEvent.newState === 'closed' && isOpen) {
        onClose();
      }
    };

    component.addEventListener('toggle', handleToggle);
    return () => component.removeEventListener('toggle', handleToggle);
  }, [componentRef, isOpen, onClose]);
};
